export default "__VITE_ASSET__C3xtO5XN__"